angular.module("dettaglioContratto.components", ['app.services']).component("dettaglioContratto", {
    templateUrl: "ng/components/dettaglioContratto/dettaglioContratto.view.html",
    bindings: {
        numero: "<",
        modulo: "<",
    },
    controllerAs: "dettaglioContrattoCtrl",
    controller: function DettaglioContratto($arcService, $location) {
        var self = this;

        self.appContract = {
            numeroContratto: null,
            modulo: null,
            cdBeni: []
        }

        self.$onInit = function () {
            self.appContract.numeroContratto = self.numero;
            self.appContract.modulo = self.modulo;
            self.getDettaglioContratto();
        };

        self.getDettaglioContratto = function () {

            self.isLoading = true;

            $arcService
                .getDettaglioContratto(self.appContract)
                .then(function (response) {
                    self.contractData = response;
                    if (self.contractData && self.contractData.dataAvvio) {
                        self.contractData.dataAvvio = self.formatDate(self.contractData.dataAvvio);
                    }
                    if (self.contractData && self.contractData.dataFine) {
                        self.contractData.dataFine = self.formatDate(self.contractData.dataFine);
                    }
                    if (self.contractData && self.contractData.dataProssimaScadenzaRata) {
                        self.contractData.dataProssimaScadenzaRata = self.formatDate(self.contractData.dataProssimaScadenzaRata);
                    }
                    if (self.contractData && self.contractData.indicizzato != null && typeof self.contractData.indicizzato != undefined) {
                        self.contractData.indicizzato = self.translateIndicizzato(self.contractData.indicizzato);
                    }
                    self.appContract.cdBeni.push(self.contractData.codProdotto);
                    if (self.contractData.cluster === 'TARGATO') {
                        self.isTargato = true;
                    }
                    if (self.contractData.anticipoPerc && self.contractData.importo) {
                        self.contractData.anticipo = self.contractData.importo * self.contractData.anticipoPerc;
                    }
                    if (self.contractData.riscattoPerc && self.contractData.importo) {
                        self.contractData.riscatto = self.contractData.importo * self.contractData.riscattoPerc;
                    }
                    if (self.contractData.abi && self.contractData.cab && self.contractData.cdCinInt && self.contractData.cinCC && self.contractData.numCC) {
                        self.contractData.coordinateBancarie = self.contractData.cdCinInt + self.contractData.cinCC + self.contractData.abi + self.contractData.cab + self.contractData.numCC;
                    }
                    self.getElencoBeni();
                    if (self.contractData.codProdotto != 'OPT' && self.contractData.codProdotto != 'OPS') {
                        self.showDettaglioCanone = true;
                        self.getDettaglioCanone();
                    }
                })
                .catch(function (error) {
                    console.log("ERROR:", error);
                    self.isLoading = false;
                })
                .finally(function () {
                    console.log("Andata!");
                    self.isLoading = false;
                })

        }

        self.getElencoBeni = function () {

            self.isPending = true;

            $arcService
                .getElencoBeni(self.appContract)
                .then(function (response) {
                    self.listBeni = response;
                })
                .catch(function (error) {
                    console.log("ERROR:", error)
                    self.isPending = false;
                })
                .finally(function () {
                    console.log("Andata!");
                    self.isPending = false;
                })

        }

        self.back = function () {
            $location.path("/mycontracts");
        }

        self.formatDate = function (date) {
            return moment(date).format("DD/MM/YYYY");
        }

        self.translateIndicizzato = function (indicizzato) {
            if (indicizzato == true) {
                return 'SI';
            } else {
                return 'NO';
            }
        }

        self.getDettaglioCanone = function () {

            self.isLoad = true;

            $arcService
                .dettaglioCanone(self.appContract.numeroContratto, self.appContract.modulo)
                .then(function (response) {
                    self.listCanone = response.rate;
                })
                .catch(function (error) {
                    console.log("ERROR:", error)
                })
                .finally(function () {
                    self.isLoad = false;
                })
        }

    }
});